module.exports = __webpack_public_path__ + "img/shutterstock-433689337-original-temp-490x340.c5ab22be.jpg";